import React from 'react'
import { CallbackComponent } from 'redux-oidc'
import { userManager } from 'auth/userManager'
import { history } from 'store/modules'
import { redirectToLogin } from 'utils/redirectTo'
import { Redirecting } from './redirecting'

const SigninCallbackPage = (props) => {
  return (
    <CallbackComponent
      userManager={userManager}
      successCallback={(user) => {
        if (user === null) {
          console.log('signing callback, user == null, redirecting to login')
          redirectToLogin()
        } else {
          history.push('/')
        }
      }}
      errorCallback={(err) => {
        console.log('sign-in callback, error:', err)
        console.log('redirecting to login...')
        redirectToLogin()
      }}>
      <Redirecting />
    </CallbackComponent>
  )
}

export {
  SigninCallbackPage
}
